// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-product[data-v-42f27d16]{font-weight:700;border-bottom:2px solid #2d8cf0}", ""]);
// Exports
module.exports = exports;
